import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import DataLayer from '../common/data-layer.js';
import style from './terms-button.style.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
var _excluded = ["pack", "onAction"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var AngleRightIcon = function AngleRightIcon(props) {
  return jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: jsx("path", {
      d: "m9.522 18.53 6-6a.754.754 0 0 0 0-1.06l-6-6a.753.753 0 0 0-.512-.201.749.749 0 0 0-.548 1.261l5.47 5.47-5.47 5.47a.749.749 0 0 0 1.06 1.06Z"
    })
  }));
};

AngleRightIcon.defaultProps = {
  viewBox: "0 0 24 24"
};

var TermsButton = function TermsButton(_ref) {
  var pack = _ref.pack,
      onAction = _ref.onAction,
      props = _objectWithoutProperties(_ref, _excluded);

  return jsx(DataLayer, {
    selector: "[TermsButton]#".concat(pack.id),
    triggers: ['click'],
    context: {
      pack: pack
    },
    render: function render(ref) {
      return jsxs("div", _objectSpread(_objectSpread({
        ref: ref,
        css: style.button,
        onClick: function onClick() {
          return onAction('show-terms');
        }
      }, props), {}, {
        children: [jsx("div", {
          children: pack.packageOption.termCondition
        }), jsx(AngleRightIcon, {
          css: style.icon
        })]
      }));
    }
  });
};

export { TermsButton as default };